<template>
  <div>
    <mendianList   > </mendianList> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import mendianList from '../../tongyong/mendian.vue';
 
export default {

  components: {
    mendianList: mendianList 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
